import MoreIcon from '@clearkit/icons/glyphs/Ellipsis';
import Divider from '@material-ui/core/Divider';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Menu from '@material-ui/core/Menu';
import { Link } from 'react-router-dom';

import MenuItem from '~/components/RedesignedMenuItem';
import paths from '~/lib/paths';

import DeleteIcon from './Delete.svg';
import EditIcon from './Edit.svg';
import NewSegmentPlusIcon from './NewSegmentMenuPlusIcon.svg';

class MoreMenu extends React.Component {
  state = {
    menuOpen: false,
  };

  moreIcon = React.createRef();

  render() {
    const { type, collection, className } = this.props;
    const { menuOpen } = this.state;

    return (
      <>
        <a
          ref={this.moreIcon}
          className={className}
          href="#none"
          onClick={(event) => {
            event.preventDefault();
            this.setState({ menuOpen: true });
          }}>
          <MoreIcon />
        </a>

        <Menu
          anchorEl={this.moreIcon.current}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          getContentAnchorEl={null}
          open={menuOpen}
          onClose={() => {
            this.setState({ menuOpen: false });
          }}>
          <MenuItem
            variant="primary"
            large
            component={Link}
            to={{
              pathname: paths.segmentNew(type),
              state: { collection_id: collection.id },
            }}
            onClick={() => {
              this.setState({ menuOpen: false });
            }}>
            <ListItemIcon>
              <NewSegmentPlusIcon />
            </ListItemIcon>
            New Audience
          </MenuItem>
          <Divider />
          <MenuItem
            variant="primary"
            onClick={() => {
              this.setState({ menuOpen: false });
              this.props.onRename();
            }}>
            <ListItemIcon>
              <EditIcon style={{ width: 14 }} />
            </ListItemIcon>
            Rename Collection
          </MenuItem>
          <MenuItem
            variant="destructive"
            onClick={() => {
              this.setState({ menuOpen: false });
              this.props.onDelete();
            }}>
            <ListItemIcon>
              <DeleteIcon />
            </ListItemIcon>
            Delete Collection...
          </MenuItem>
        </Menu>
      </>
    );
  }
}

MoreMenu.propTypes = {
  className: PropTypes.string,
  type: PropTypes.oneOf(['Company', 'Person']).isRequired,
  collection: PropTypes.object.isRequired,
  onRename: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default MoreMenu;
